import { computed } from 'vue'

import { useNavItemsStore } from '@/stores/navigationItems'

export const fetchUpperNavigationMenu = async () => {
  const navItemsStore = useNavItemsStore()

  try {
    await navItemsStore.fetchButterUpperNav()
  } catch (error) {
    console.error('Error during fetching main nav:', error)
  } finally {
    navItemsStore.updateIsLoadedUpper(true)
  }
}

export const useNavigationUpperData = async () => {
  const navItemsStore = useNavItemsStore()

  if (!navItemsStore.getIsLoadedUpper) {
    await fetchUpperNavigationMenu()
  }

  return computed(() => navItemsStore.getNavUpper)
}

export const getLoadedState = () => {
  const navItemsStore = useNavItemsStore()
  return computed(() => navItemsStore.getIsLoadedUpper)
}
